/**
 * Phonics Letter Bb — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/bb/）
 *
 * 统一数据结构：
 * {
 *   layout: '...',
 *   videos: [{ src, poster? }],
 *   lines: [{ en, cn?, audioEn, audioCn? }],
 *   splitAt?: number,
 * }
 */

const MEDIA_BASE = '/media/phonics/bb';
const V = 'v1';

export const letterData = {
  letter: 'B',
  title: 'Phonics',
  subtitle: 'Letter B',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Bb.mp4?${V}`,
    startTime: 8,
    endTime: 103,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  storySections: [
    // Step 3: Learn the words (1) — make / me / a + make me a ...
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_make.mp4?${V}`, poster: `${MEDIA_BASE}/image11.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'make', cn: '制作', audioEn: `${MEDIA_BASE}/w_en_make.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_make.mp3?${V}` },
        { en: 'me', cn: '我', audioEn: `${MEDIA_BASE}/w_en_me.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_me.mp3?${V}` },
        { en: 'a', cn: '一个/一把/一条/一辆', audioEn: `${MEDIA_BASE}/w_en_a.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_a.mp3?${V}` },
        { en: 'make me a ...', cn: '为我制作一个……', audioEn: `${MEDIA_BASE}/s_en_make_me_a_.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_make_me_a_.mp3?${V}` },
      ],
    },

    // Step 4: Learn the words (2+3 合并) — jump / jump into + jump on (去重复)
    {
      label: 'Learn the words',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words2_jump.mp4?${V}`, poster: `${MEDIA_BASE}/image12.png?${V}`, lines: [
          { en: 'jump', cn: '跳', audioEn: `${MEDIA_BASE}/w_en_jump.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_jump.mp3?${V}` },
          { en: 'jump into', cn: '跳进', audioEn: `${MEDIA_BASE}/w_en_jump_into.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_jump_into.mp3?${V}` },
        ]},
        { src: `${MEDIA_BASE}/video_words3_jump_on.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}`, lines: [
          { en: 'jump on', cn: '跳上', audioEn: `${MEDIA_BASE}/w_en_jump_on.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_jump_on.mp3?${V}` },
        ]},
      ],
    },

    // Step 6: Learn the Story (1) — boat
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_boat.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'a boat', cn: '一条船', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'make me a boat', cn: '为我制作一条船', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'jump into my boat', cn: '跳进我的船', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Step 7: Learn the Story (2) — bike
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_bike.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'a bike', cn: '一辆自行车', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'make me a bike', cn: '为我制作一辆自行车', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'jump on my bike', cn: '跳上我的自行车', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // Step 8: Learn the Story (3) — bus
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_bus.mp4?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` }],
      lines: [
        { en: 'a bus', cn: '一辆大巴士', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'make me a bus', cn: '为我制作一辆大巴士', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'jump into my bus', cn: '跳进我的大巴士', audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
      ],
    },
  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
